<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Shifts</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <base-input label="Staff">
                <multiselect
                  placeholder="Select Staff"
                  v-model="cmbStaff.value"
                  :options="cmbStaff.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbStaff"
                  :disabled="this.myObj.id > 0"
                >
                </multiselect>
              </base-input>

              <base-input label="Day">
                <multiselect
                  placeholder="Select Day"
                  v-model="cmbDay.value"
                  :options="cmbDay.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbDay"
                >
                </multiselect>
              </base-input>

              <base-input label="From">
                <multiselect
                  placeholder="Timings From:"
                  v-model="cmbFrom.value"
                  :options="cmbFrom.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbFrom"
                >
                </multiselect>
              </base-input>

              <base-input label="To">
                <multiselect
                  placeholder="Timings To"
                  v-model="cmbTo.value"
                  :options="cmbTo.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbTo"
                >
                </multiselect>
              </base-input>
              <div>
                <base-button
                  @click="AddShift()"
                  :disabled="saving"
                  type="primary"
                  class="col"
                  ><i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div style="margin-bottom: 5px">
                <base-button icon type="primary" @click="AddModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Add new staff</span>
                </base-button>

                <base-button
                  hidden
                  icon
                  v-if="selectedRows.length"
                  type="danger"
                  @click="RemoveSelected()"
                >
                  <span class="btn-inner--icon"
                    ><i class="fas fa-trash"></i
                  ></span>
                  <span class="btn-inner--text">Remove selected</span>
                </base-button>
              </div>

              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <!-- <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div> -->
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import Multiselect from "vue-multiselect";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Multiselect,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    this.LoadData();
    this.FillCmb();
    this.FillStaff();
  },
  data() {
    return {
      myObj: {
        staffID: 0,
        day: null,
        oldShift: null,
        shift: null,
        timeFrom: 0,
        timeTo: 0,
        id: 0,
        oldDay: null,
      },

      propsToSearch: ["firstName"],
      tableColumns: [
        {
          prop: "firstName",
          label: "First name",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "day",
          label: "Day",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "shift",
          label: "Shift",
          minWidth: 150,
          sortable: true,
        },
      ],
      cmbFrom: {
        value: {},
        data: [],
      },
      cmbTo: {
        value: {},
        data: [],
      },
      cmbStaff: {
        value: {},
        data: [],
      },
      cmbDay: {
        value: {
          name: "Sunday",
          value: "Sun",
        },
        data: [
          {
            name: "Sunday",
            value: "Sun",
          },
          {
            name: "Monday",
            value: "Mon",
          },
          {
            name: "Tuesday",
            value: "Tue",
          },
          {
            name: "Wednesday",
            value: "Wed",
          },
          {
            name: "Thrusday",
            value: "Thu",
          },
          {
            name: "Firday",
            value: "Fri",
          },
          {
            name: "Saturday",
            value: "Sat",
          },
        ],
      },
      tableData: [],
      selectedRows: [],
      modals: {
        showModal: false,
      },
      optionName: "Save",
      name: "",
      prefixname: "",
      prefixError: false,
      fnError: false,
      lnError: false,
      countryError: false,
      ratingError: false,
      specError: false,
      desError: false,
      statusError: false,
      flagError: false,
      sign: "fas fa-plus",
      shouldAdd: true,
      saving: false,
      eIndex: 0,
    };
  },
  methods: {
    LoadData() {
      var url = this.$store.state.domain + "/slots";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
          } else {
            this.tableData = response.data;
          }
        })
        .catch(function (error) {});
    },
    FillCmb() {
      var url = this.$store.state.domain + "/bookings/times";
      axios
        .get(url)
        .then((res) => {
          console.log("Times", res.data);
          this.cmbFrom.value = null;
          this.cmbFrom.data = [];

          this.cmbTo.value = null;
          this.cmbTo.data = [];
          res.data.forEach((elem) => {
            this.cmbFrom.data.push({
              name: elem.time,
              value: elem.timeValue,
            });

            this.cmbTo.data.push({
              name: elem.time,
              value: elem.timeValue,
            });
          });
        })
        .catch((err) => {
          console.error("cmbCat Fill", err);
        });
    },

    FillStaff() {
      var url = this.$store.state.domain + "/staff";
      axios
        .get(url)
        .then((res) => {
          console.log("staff", res.data);
          this.cmbStaff.value = null;
          this.cmbStaff.data = [];
          res.data.forEach((elem) => {
            this.cmbStaff.data.push({
              name: elem.firstName,
              value: elem.staffID,
            });
          });
        })
        .catch((err) => {
          console.error("staff Fill", err);
        });
    },

    GetError() {
      return this.fnError;
      return this.flagError;
    },
    AddShift() {
      if (this.cmbStaff.value === null || this.cmbStaff.value.length === 0) {
        alert("Please select a staff");
      } else if (this.cmbDay.value === null || this.cmbDay.value.length === 0) {
        alert("Please select a Day");
      } else if (
        this.cmbFrom.value === null ||
        this.cmbFrom.value.length === 0 ||
        this.cmbTo.value === null ||
        this.cmbTo.value.length === 0
      ) {
        alert("Please select shift duration");
      } else {
        this.myObj.day = this.cmbDay.value.value;
        this.myObj.staffID = this.cmbStaff.value.value;
        this.myObj.timeFrom = parseFloat(this.cmbFrom.value.value);
        this.myObj.timeTo = parseFloat(this.cmbTo.value.value);
        this.myObj.shift =
          this.cmbFrom.value.name + " - " + this.cmbTo.value.name;

        if (this.myObj.id > 0) {
          //edit
          axios
            .put(this.$store.state.domain + "/slots/save", this.myObj)
            .then((res) => {
              this.modals.showModal = false;
              this.LoadData();
            })
            .catch((error) => console.error(error));
        } else {
          //add
          axios
            .post(this.$store.state.domain + "/slots", this.myObj)
            .then((res) => {
              this.modals.showModal = false;
              this.LoadData();
            })
            .catch((error) => console.error(error));
        }

        // this.cmbDay.value.forEach((elem) => {

        // });
      }
    },
    AddModal() {
      this.modals.showModal = true;
      this.saving = false;

      this.myObj.staffID = 0;
      this.myObj.day = null;
      this.myObj.oldShift = null;
      this.myObj.shift = null;
      this.myObj.timeFrom = 0;
      this.myObj.timeTo = 0;
      this.myObj.id = 0;

      this.myObj.oldDay = null;

      this.cmbStaff.value = null;
      this.cmbDay.value = null;
      this.cmbFrom.value = null;
      this.cmbTo.value = null;

      this.optionName = "Save";

      this.sign = "fas fa-edit";
    },
    editRecord(index, row) {
      this.myObj.staffID = 0;
      this.myObj.day = null;
      this.myObj.oldShift = null;
      this.myObj.shift = null;
      this.myObj.timeFrom = 0;
      this.myObj.timeTo = 0;
      this.myObj.id = 0;

      this.cmbStaff.value = null;
      this.cmbDay.value = null;
      this.cmbFrom.value = null;
      this.cmbTo.value = null;

      this.cmbStaff.data.forEach((elem) => {
        if (elem.value === row.staffID) this.cmbStaff.value = elem;
      });

      this.cmbDay.data.forEach((elem) => {
        if (elem.value === row.day) this.cmbDay.value = elem;
      });

      this.cmbFrom.data.forEach((elem) => {
        if (elem.value === row.timeFrom) this.cmbFrom.value = elem;
      });

      this.cmbTo.data.forEach((elem) => {
        if (elem.value === row.timeTo) this.cmbTo.value = elem;
      });

      this.myObj.oldShift = row.shift;
      this.myObj.id = row.id;
      this.myObj.oldDay = row.day;

      this.shouldAdd = false;
      this.optionName = "Edit";
      this.modals.showModal = true;
      this.sign = "far fa-edit";
    },
    handleDelete(index, row) {
      var sID = row.staffID;
      console.log("ST ID", sID);
      swal({
        title: "Are you sure?",
        text: "You want to delete shift of " + row.day + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          //Remove API
          var url =
            this.$store.state.domain +
            "/slots/" +
            row.staffID +
            "/" +
            row.day +
            "/" +
            row.shift;
          console.log("Remove: " + url);
          axios
            .delete(url, qs.stringify(""))
            .then((response) => {
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: 'Done! <br />Shift of "' + row.day + '" removed.',
                  type: "danger",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });

                this.LoadData();
              }
            })
            .catch(function (error) {
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message: "Request Error! <br />" + response.data.data,
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.staffID === row.staffID
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  computed: {
    getData() {
      return this.$store.state.gridData;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
